// Action types
export const gtmEventTypes = {
  SOCIAL_ICON_CLICK: 'FED-GLF-001',
  CLICKED_EDIT_POSTCODE: 'FED-GLF-002',
  CLICKED_FOOTER_LINK: 'CMS-GLF-003',
}

// Action creators
export const gtmEvents = {
  [gtmEventTypes.SOCIAL_ICON_CLICK]: ({platform}) => ({
    type: gtmEventTypes.SOCIAL_ICON_CLICK,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SOCIAL_ICON_CLICK,
    pageCategory: 'Footer Nav',
    pageAction: `Footer - Clicked "${platform.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICKED_EDIT_POSTCODE]: () => ({
    type: gtmEventTypes.CLICKED_EDIT_POSTCODE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICKED_EDIT_POSTCODE,
    pageCategory: 'Footer Nav',
    pageAction: 'Footer - Selected Change Postcode',
  }),
  [gtmEventTypes.CLICKED_FOOTER_LINK]: ({
                                          CMSGroupGTM,
                                        }) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICKED_FOOTER_LINK,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/global-footer-duck.js